export default "__VITE_ASSET__CXLQWzv5__"